module.exports = __webpack_public_path__ + "static/media/step2.e0678d4f.png";